import React, { forwardRef } from 'react'
import classnames from 'classnames'

/**
 * Component for backdrops eg. a black opaque overlay 
 * when modal is active
 */
const Backdrop = forwardRef((props, ref) => {
	let __backdrop__ = classnames(
		'app-backdrop',
	)
	
	return (
		<div 
			ref={ref}
			className={__backdrop__}
			onClick={props.onClickHandler}
			style={{
				...props.style
			}}
		   
		/>
	)
})

export default Backdrop
